import { AfterViewInit, Component, ElementRef, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-fraud-monitoring-tasks-comment-controls',
  standalone: false,
  templateUrl: './fraud-monitoring-tasks-comment-controls.component.html'
})
export class FraudMonitoringTasksCommentControlsComponent implements OnInit, OnChanges, AfterViewInit {
  formGroup!: FormGroup;
  commentForWhomsList: any[] = [];
  @Input() selectedRecord!: any | null;
  @Output() submitComment = new EventEmitter()
  @Output() cancelEdit = new EventEmitter()
  @ViewChild('autoInput') autoInput!: ElementRef;


  constructor(
    private formBuilder: FormBuilder,
    private translate: TranslateService,
  ) {
    this.buildForm();

  }
  ngOnInit(): void {
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (
      changes && changes['selectedRecord']
      && changes['selectedRecord'].currentValue
      && this.formGroup
    ) {
      this.formGroup.controls['comment'].setValue(changes['selectedRecord'].currentValue.comment)
    }
  }

  ngAfterViewInit(): void {
    // this.autoInput.nativeElement.focus();
  }

  buildForm(value = null) {
    this.formGroup = this.formBuilder.group({
      comment: [value ? value : null, Validators.required],
    });
  }

  submit() {
    if (this.formGroup.valid) {
      this.submitComment.emit(this.formGroup.value)
      this.formGroup.controls['comment'].setValue(null);
      this.selectedRecord = null
    }
  }

  cancel() {
    this.cancelEdit.emit(true)
  }

  hasError(controlName: string, errorName: string) {
    return this.formGroup.controls[controlName].hasError(errorName);
  }

}
